<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'teamList' }"> {{$t('entities.tournament.singular')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title">
       {{$t('entities.tournament.singular')}} {{$t('table.history')}}
    </h2>

    <div v-loading="loading">
      <el-table
        :data="list"
        empty-text="There is no history yet"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="modified"
          label="Updated at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.modified | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Updated by"
          prop="modifiedBy.email"
        ></el-table-column>

        <el-table-column
          prop="name"
          label="Name"
        ></el-table-column>

        <el-table-column
          prop="category"
          label="Category"
        >
          <template slot-scope="scope">
            {{ scope.row.category ? scope.row.category.label : '' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="club"
          label="Club"
        >
          <template slot-scope="scope">
            {{ scope.row.club ? scope.row.club.name : '' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="locality"
          label="Locality"
        ></el-table-column>

        <!-- <el-table-column
          prop="players"
          label="Players"
        >
          <template slot-scope="scope">
            <div
              v-for="players in scope.row.players"
              :key="players.id"
            >
              {{ players.label }}
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="country"
          label="Country"
        ></el-table-column>

        <el-table-column
          prop="web"
          label="Web"
        ></el-table-column>

        <el-table-column
          prop="created"
          label="Created at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.created | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Created by"
          prop="createdBy.email"
        ></el-table-column>

        <el-table-column
          prop="deleted"
          label="Deleted at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.deleted | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Deleted by"
          prop="deletedBy.email"
        ></el-table-column>
      </el-table>

      <el-button
        v-if="!last"
        @click="fetch()"
        type="infor"
        class="mt-3 w-100"
        icon="el-icon-fa-plus"
      >
        Load more...
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-team-history-full',

  computed: {
    ...mapGetters({
      loading: 'entities/team/historyFull/loading',
      list: 'entities/team/historyFull/list',
      last: 'entities/team/historyFull/last',
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/team/historyFull/setup'
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/team/historyFull/clear',
    );
    next();
  },

  methods: {
    ...mapActions({
      fetch: 'entities/team/historyFull/fetch',
    }),
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full.vue?52dad685